<template>
  <div
    class="schedule_match_list complex"
    :class="[
      themeClass === 'onlyDisplay' ? 'onlyDisplay' : '',
      viewMode,
      customClassName,
    ]"
  >
    <div
      class="match_list_item"
      :class="[
        matchItemIsShareClassName(item),
        item.isChooseFlag ? 'chooseAct' : '',
        matchModeObj ? matchModeObj.mode : '',
      ]"
      v-for="item in data"
      :key="item.matchId"
      @click="goDetail(item)"
    >
      <template
        v-if="
          matchModeObj &&
          ['FIFAWorldCup', 'badminton'].includes(matchModeObj.mode)
        "
      >
        <span class="item_matchLeft">
          <template
            v-if="
              [
                'scheduleNoticeFootballCup',
                'scheduleNoticeThomasAndUber',
              ].includes(viewMode) && chooseState === 'choose'
            "
          >
            <span class="matchLeft_colum1">
              <span
                class="matchLeft_colum1_row1"
                v-text="
                  _valPerFormatHandler(
                    matchModeObj.type == 'matchDate'
                      ? item.stageNameWeb
                      : item.weekCN
                  )
                "
              ></span>
              <span class="matchLeft_colum1_row2">
                <span
                  class="matchItem_checkbox"
                  v-for="channelItem in item.channelTvList"
                  :class="channelItem.act ? 'act' : ''"
                  :key="`${item.matchId}_${channelItem.value}`"
                  @click.stop="matchItem_checkbox(item, channelItem)"
                >
                  <span class="matchItem_channelItem" :class="channelType">
                    <svg
                      t="1693726421166"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="21127"
                      width="80%"
                      height="80%"
                    >
                      <path
                        d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
                        p-id="21128"
                      ></path>
                    </svg>
                  </span>
                  <span
                    class="matchItem_channelItem_text"
                    v-text="channelItem.name"
                  ></span>
                </span>
              </span>
            </span>
          </template>
          <template
            v-else-if="
              [
                'scheduleNoticeFootballCup',
                'scheduleNoticeThomasAndUber',
              ].includes(viewMode) && themeClass === 'onlyDisplay'
            "
          >
            <span class="matchLeft_colum1">
              <span
                class="matchLeft_colum1_row1"
                v-text="
                  _valPerFormatHandler(
                    matchModeObj.type == 'matchDate'
                      ? item.stageNameWeb
                      : item.weekCN
                  )
                "
              ></span>
              <span class="matchLeft_colum1_row2">
                <span
                  class="matchItem_checkbox"
                  v-for="channelItem in item.channels"
                  :key="channelItem.channelId"
                >
                  <span
                    class="matchItem_channelItem_text channelName"
                    v-text="channelItem.channelName"
                  ></span>
                </span>
              </span>
            </span>
          </template>
          <template v-else>
            <span
              class="matchLeft_colum1"
              :class="matchModeObj.type"
              v-text="
                _valPerFormatHandler(
                  matchModeObj.type == 'matchDate'
                    ? item.stageNameWeb
                    : item.weekCN
                )
              "
            ></span>
          </template>
        </span>

        <span class="item_matchCenter" v-if="matchStatusOpts">
          <span class="matchCenter_leftTeam">
            <span class="teamName" v-text="item.homeName"></span>
            <img :src="item.homeLogo" />
          </span>
          <span class="matchCenter_scoreArea">
            <span
              class="matchStatus_notStarted"
              v-if="
                item.matchStatus ==
                  matchStatusOpts.matchStatusCode2CN.Fixture ||
                item.matchStatus == matchStatusOpts.matchStatusCode2CN.Postponed
              "
              v-text="item.matchTime"
            ></span>
            <span
              v-else-if="
                item.matchStatus ==
                  matchStatusOpts.matchStatusCode2CN.Playing ||
                item.matchStatus ==
                  matchStatusOpts.matchStatusCode2CN.Suspended ||
                item.matchStatus == matchStatusOpts.matchStatusCode2CN.Played
              "
              :class="[
                item.matchStatus == matchStatusOpts.matchStatusCode2CN.Played
                  ? 'matchStatus_over'
                  : 'matchStatus_ongoing',
              ]"
            >
              <span v-text="item.homeScore"></span>
              <span v-text="item.awayScore"></span>
            </span>
            <span v-else></span>
          </span>
          <span class="matchCenter_rightTeam">
            <img :src="item.awayLogo" />
            <span class="teamName" v-text="item.awayName"></span>
          </span>
        </span>
        <span class="item_matchRight">
          <i class="matchRight_icon"></i>
          <span class="matchRight_text" v-text="item.venueName"></span>
        </span>
      </template>
      <template
        v-else-if="
          matchModeObj &&
          ['compreSportsMeet', 'tennis'].includes(matchModeObj.mode)
        "
      >
        <span
          class="item_matchLeft"
          :class="[
            viewMode.indexOf('scheduleNotice') === 0
              ? 'isShowChannelTvList'
              : '',
            ['tennis'].includes(matchModeObj.mode)
              ? 'doubleNationalityOfTeam'
              : '',
          ]"
        >
          <template v-if="viewMode.indexOf('scheduleNotice') === 0">
            <span class="matchLeft_colum1">
              <span class="matchLeft_colum1_row1">
                <!-- <span
                  v-if="themeClass === 'onlyDisplay'"
                  class="matchLeft_colum1_row1_colum1"
                  v-text="
                    _valPerFormatHandler(
                      `${item.formatDate ? item.formatDate : ''} ${
                        item.matchTime
                      }`
                    )
                  "
                ></span> -->
                <span
                  class="matchLeft_colum1_row1_colum1"
                  v-text="
                    _valPerFormatHandler(
                      `${item.formatDate ? item.formatDate : ''} ${
                        item.matchTime
                      }`
                    )
                  "
                ></span>
                <span class="matchLeft_colum1_row1_colum2">
                  <span class="national_icon" v-if="item.isChina"></span>
                  <span class="medal_icon" v-if="item.isGold"></span>
                </span>
              </span>

              <span class="matchLeft_colum1_row2" :data="`${chooseState}`">
                <template v-if="chooseState === 'choose'">
                  <span
                    class="matchItem_checkbox"
                    v-for="channelItem in item.channelTvList"
                    :class="channelItem.act ? 'act' : ''"
                    :key="channelItem.value"
                    @click.stop="matchItem_checkbox(item, channelItem)"
                  >
                    <span class="matchItem_channelItem" :class="channelType">
                      <svg
                        t="1693726421166"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="21127"
                        width="80%"
                        height="80%"
                      >
                        <path
                          d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
                          p-id="21128"
                        ></path>
                      </svg>
                    </span>
                    <span
                      class="matchItem_channelItem_text"
                      v-text="channelItem.name"
                    ></span>
                  </span>
                </template>
                <template v-else>
                  <span
                    class="matchItem_checkbox"
                    v-for="channelItem in item.channels"
                    :key="channelItem.channelId"
                  >
                    <span
                      class="matchItem_channelItem_text channelName"
                      v-text="channelItem.channelName"
                    ></span>
                  </span>
                </template>
              </span>
            </span>
            <span class="matchLeft_colum2">
              <span
                class="matchLeft_colum2_row1"
                v-text="_valPerFormatHandler(item.matchName)"
              ></span>
              <span class="matchLeft_colum2_row2">
                <span class="sportHall_icon"></span>
                <span
                  class="sportHall_name"
                  v-text="_valPerFormatHandler(item.venueName)"
                ></span>
              </span>
            </span>
          </template>
          <template v-else>
            <span class="matchLeft_colum1">
              <!-- <span
                v-if="themeClass === 'onlyDisplay'"
                class="matchLeft_colum1_row1"
                v-text="
                  _valPerFormatHandler(
                    `${item.formatDate ? item.formatDate : ''} ${
                      item.matchTime
                    }`
                  )
                "
              ></span> -->
              <span
                class="matchLeft_colum1_row1"
                v-text="
                  _valPerFormatHandler(
                    `${item.formatDate ? item.formatDate : ''} ${
                      item.matchTime
                    }`
                  )
                "
              ></span>
              <span class="matchLeft_colum1_row2">
                <span class="national_icon" v-if="item.isChina"></span>
                <span class="medal_icon" v-if="item.isGold"></span>
              </span>
            </span>
            <span class="matchLeft_colum2">
              <span
                class="matchLeft_colum2_row1"
                v-text="_valPerFormatHandler(item.matchName)"
              ></span>
              <span class="matchLeft_colum2_row2">
                <span class="sportHall_icon"></span>
                <span
                  class="sportHall_name"
                  v-text="_valPerFormatHandler(item.venueName)"
                ></span>
              </span>
            </span>
          </template>
        </span>
        <span
          class="item_matchCenter"
          :class="[
            item.type,
            ['tennis'].includes(matchModeObj.mode)
              ? 'doubleNationalityOfTeam'
              : '',
          ]"
        >
          <template
            v-if="
              item.type === sportsTypeArr[0] &&
              ['compreSportsMeet'].includes(matchModeObj.mode)
            "
          >
            <!-- 综合性赛事双打运动员是同一国籍 -->
            <span class="matchCenter_colum1">
              <span class="matchCenter_colum1_row">
                <span
                  class="delegationLogo"
                  :class="item.homeLogo ? 'isLogo' : ''"
                >
                  <img v-if="item.homeLogo" :src="item.homeLogo" />
                </span>
                <span
                  class="delegationName"
                  v-text="_valPerFormatHandler(item.homeName)"
                ></span>
              </span>
              <span class="matchCenter_colum1_row">
                <span
                  class="delegationLogo"
                  :class="item.awayLogo ? 'isLogo' : ''"
                >
                  <img v-if="item.awayLogo" :src="item.awayLogo" />
                </span>
                <span
                  class="delegationName"
                  v-text="_valPerFormatHandler(item.awayName)"
                ></span>
              </span>
            </span>
            <span class="matchCenter_colum2">
              <span
                class="matchCenter_colum2_row"
                v-text="item.homeScore"
              ></span>
              <span
                class="matchCenter_colum2_row"
                v-text="item.awayScore"
              ></span>
            </span>
          </template>
          <template
            v-else-if="
              item.type === sportsTypeArr[0] &&
              ['tennis'].includes(matchModeObj.mode)
            "
          >
            <!-- 中网双打运动员不同国籍 -->
            <span class="matchCenter_colum1">
              <span
                class="teamColum"
                :class="[
                  item.competitorType === 'D' ? 'twoRow' : 'oneRow',
                  item.competitorType,
                ]"
              >
                <span
                  class="matchCenter_colum1_row"
                  v-for="playerItem in item.competitor1Names"
                  :key="playerItem.athleteCode"
                >
                  <span
                    class="delegationLogo"
                    :class="playerItem.countryLogo ? 'isLogo' : ''"
                  >
                    <img
                      v-if="playerItem.countryLogo"
                      :src="playerItem.countryLogo"
                    />
                  </span>
                  <span
                    class="delegationName"
                    v-text="_valPerFormatHandler(playerItem.athleteName)"
                  ></span>
                </span>
              </span>
              <span
                class="teamColum"
                :class="[
                  item.competitorType === 'D' ? 'twoRow' : 'oneRow',
                  item.competitorType,
                ]"
              >
                <span
                  class="matchCenter_colum1_row"
                  v-for="playerItem in item.competitor2Names"
                  :key="playerItem.athleteCode"
                >
                  <span
                    class="delegationLogo"
                    :class="playerItem.countryLogo ? 'isLogo' : ''"
                  >
                    <img
                      v-if="playerItem.countryLogo"
                      :src="playerItem.countryLogo"
                    />
                  </span>
                  <span
                    class="delegationName"
                    v-text="_valPerFormatHandler(playerItem.athleteName)"
                  ></span>
                </span>
              </span>
            </span>
            <span class="matchCenter_colum2">
              <span
                class="matchCenter_colum2_row"
                v-text="item.homeScore"
              ></span>
              <span
                class="matchCenter_colum2_row"
                v-text="item.awayScore"
              ></span>
            </span>
          </template>
          <template v-else>
            <span
              class="matchCenter_colum1"
              v-if="item.medalist && item.medalist.length > 0"
            >
              <span
                class="matchCenter_colum1_row"
                v-for="ceil in item.medalist"
                :key="ceil.playerId"
              >
                <span
                  class="delegationLogo"
                  :class="ceil.delegationLogo ? 'isLogo' : ''"
                >
                  <img v-if="ceil.delegationLogo" :src="ceil.delegationLogo" />
                </span>
                <span
                  v-if="ceil.mcompetitorType === 'A'"
                  class="delegationName"
                  v-text="_valPerFormatHandler(ceil.playerName)"
                ></span>
                <span
                  v-if="ceil.mcompetitorType === 'T'"
                  class="delegationName"
                  v-text="_valPerFormatHandler(ceil.delegationName)"
                ></span>
              </span>
            </span>
            <span class="matchCenter_colum2">
              <span
                v-for="ceil in item.medalist"
                :key="ceil.playerId"
                class="matchCenter_colum2_row"
              >
                <span class="medalIcon" :class="ceil.medalType"></span>
              </span>
            </span>
          </template>
        </span>
        <!-- 对于比赛预告，比赛状态无所谓，因为肯定是未开始的比赛才会被选中，宽度不够所以隐藏比赛状态 -->
        <span
          class="item_matchRight"
          v-show="viewMode.indexOf('scheduleNotice') === -1"
        >
          <span
            class="matchRight_status"
            :class="matchStatusClassName(item)"
            v-text="matchStatusToMatchCN(item.matchStatus)"
          ></span>
        </span>
      </template>
      <template
        v-else-if="
          matchModeObj &&
          ['FootballLeague', 'BasketballLeague'].includes(matchModeObj.mode)
        "
      >
        <span class="item_matchLeft">
          <template
            v-if="viewMode === 'scheduleNoticeCBA' && chooseState === 'choose'"
          >
            <span class="matchLeft_colum1">
              <span
                class="matchLeft_colum1_row1"
                v-text="_valPerFormatHandler(`${item.weekCN} ${item.gameTime}`)"
              ></span>
              <span class="matchLeft_colum1_row2">
                <span
                  class="matchItem_checkbox"
                  v-for="channelItem in item.channelTvList"
                  :class="channelItem.act ? 'act' : ''"
                  :key="channelItem.value"
                  @click.stop="matchItem_checkbox(item, channelItem)"
                >
                  <span class="matchItem_channelItem" :class="channelType">
                    <svg
                      t="1693726421166"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="21127"
                      width="80%"
                      height="80%"
                    >
                      <path
                        d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
                        p-id="21128"
                      ></path>
                    </svg>
                  </span>
                  <span
                    class="matchItem_channelItem_text"
                    v-text="channelItem.name"
                  ></span>
                </span>
              </span>
            </span>
          </template>
          <template
            v-else-if="
              viewMode === 'scheduleNoticeCBA' && themeClass === 'onlyDisplay'
            "
          >
            <span class="matchLeft_colum1">
              <span
                class="matchLeft_colum1_row1"
                v-text="
                  _valPerFormatHandler(`${item.matchWeek} ${item.matchTime}`)
                "
              ></span>
              <span class="matchLeft_colum1_row2">
                <span
                  class="matchItem_checkbox"
                  v-for="channelItem in item.channels"
                  :key="channelItem.channelId"
                >
                  <span
                    class="matchItem_channelItem_text channelName"
                    v-text="channelItem.channelName"
                  ></span>
                </span>
              </span>
            </span>
          </template>
          <template v-else>
            <span class="matchLeft_colum1">
              <span
                class="matchLeft_colum1_row1"
                v-text="_valPerFormatHandler(item.matchName)"
              ></span>
              <span
                v-if="themeClass === 'onlyDisplay'"
                class="matchLeft_colum1_row2"
                v-text="
                  _valPerFormatHandler(
                    `${item.gameDate ? item.gameDate : ''} ${item.gameTime}`
                  )
                "
              ></span>
              <span
                v-else
                class="matchLeft_colum1_row2"
                v-text="_valPerFormatHandler(item.gameTime)"
              ></span>
            </span>
          </template>
        </span>
        <span class="item_matchCenter combat">
          <span class="matchCenter_colum1">
            <span class="matchCenter_colum1_row">
              <span
                class="delegationLogo"
                :class="item.homeLogo ? 'isLogo' : ''"
              >
                <img v-if="item.homeLogo" :src="item.homeLogo" />
              </span>
              <span
                class="delegationName"
                v-text="_valPerFormatHandler(item.homeName)"
              ></span>
            </span>
            <span class="matchCenter_colum1_row">
              <span
                class="delegationLogo"
                :class="item.awayLogo ? 'isLogo' : ''"
              >
                <img v-if="item.awayLogo" :src="item.awayLogo" />
              </span>
              <span
                class="delegationName"
                v-text="_valPerFormatHandler(item.awayName)"
              ></span>
            </span>
          </span>
          <span class="matchCenter_colum2" :class="matchStatusClassName(item)">
            <span class="matchCenter_colum2_row" v-text="item.homeScore"></span>
            <span class="matchCenter_colum2_row" v-text="item.awayScore"></span>
          </span>
        </span>
        <span class="item_matchRight">
          <template v-if="themeClass === 'onlyDisplay'">
            <span
              class="matchRight_status"
              :class="matchStatusClassName(item)"
              v-text="_valPerFormatHandler(item.matchStatusName)"
            ></span>
          </template>
          <template v-else>
            <span
              class="matchRight_status"
              :class="matchStatusClassName(item)"
              v-text="matchStatusToMatchCN(item.matchStatus, item)"
            ></span>
          </template>
        </span>
      </template>
      <span class="item_absChoose" v-show="chooseState === 'choose'">
        <span class="checkbox_item">
          <svg
            t="1693726421166"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="21127"
            width="80%"
            height="80%"
          >
            <path
              d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
              p-id="21128"
            ></path>
          </svg>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
// 目前支持的赛事 【足球世界杯（只差校对播出单展示的效果，其他同步完成）| 综合性赛事 | 羽毛球】
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'schedule_match_list',
  mixins: [cup_base_data_mixin],
  props: {
    data: {
      type: Array,
      default: () => {
        return []
        // return [
        //   {
        //     matchId: 1,
        //     matchName: '篮球·男子预赛A组',
        //     type: 'combat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: false,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Playing',
        //     matchTime: '12:30',
        //     venueName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 2,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     venueName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 3,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     venueName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 4,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     venueName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        // ]
      },
    },
    detailPathName: {
      type: [String, Array],
      default: '',
    },
    chooseState: {
      type: String,
      default: 'default', //['default', 'choose', 'none'] none：没有鼠标经过效果
    },
    localStorageName: {
      type: String,
      default: '',
    },
    localStorageSaveDate: {
      type: String,
      default: '',
    },
    themeClass: {
      // 不同页面视图的展示
      type: String,
      default: '', //onlyDisplay: 不可点击（播出单等页面）；poster: 点击只是选中比赛，不进入赛果（海报库）
    },
    viewMode: {
      // 相同页面，控制不同视图的展示
      type: String,
      default: '',
    },
    matchModeObj: {
      // 各个赛事都有赛程，但是也有互相复用的，因此抽离一个共用的赛程视图
      type: [Object, null],
      default: () => ({
        mode: '', //['compreSportsMeet', 'FIFAWorldCup']=['综合性赛事', '足球世界杯'|'世界杯亚洲预选赛', ]
        type: '',
        filterCondition: '',
        // any: xxx, 根据不同情况添加不同字段
      }),
    },
    channelType: {
      type: String,
      default: 'radio', //频道选择的模式，radio:单选；checkbox:多选
    },
    filterCondition: {
      // 目前只用在足球世界杯筛选 字母 和 球队 时使用
      type: [String, Number],
      default: '-1',
    },
    matchStatusOpts: {
      type: [Object, null],
      default: null,
      // default: () => ({
      //   apiVal2WebValMap: {
      //     CANCELLED: 3,
      //     DELAYED: 3,
      //     FINISHED: 2,
      //     GETTING_READY: 0,
      //     INTERRUPTED: 3,
      //     POSTPONED: 3,
      //     RESCHEDULED: 3,
      //     RUNNING: 1,
      //     SCHEDULED: 0,
      //     SCHEDULED_BREAK: 1,
      //     UNSCHEDULED: 2,
      //   },
      //   webValStyleArr: [
      //     {
      //       colorClass: 'unstart',
      //       key: ['GETTING_READY', 'SCHEDULED'],
      //       name: ['已就绪', '按日程计划'],
      //     },
      //     {
      //       colorClass: 'playing',
      //       key: ['RUNNING', 'SCHEDULED_BREAK'],
      //       name: ['比赛中', '中场休息'],
      //     },
      //     {
      //       colorClass: 'finished',
      //       key: ['FINISHED', 'UNSCHEDULED'],
      //       name: ['已结束', '未安排'],
      //     },
      //     {
      //       colorClass: 'other',
      //       key: [
      //         'CANCELLED',
      //         'DELAYED',
      //         'INTERRUPTED',
      //         'POSTPONED',
      //         'RESCHEDULED',
      //       ],
      //       name: ['已取消', '延误', '中断', '推迟', '改期'],
      //     },
      //   ],
      //   matchStatusCode2CN: {
      //     //足球世界杯
      //     Cancelled: 'Cancelled', // 取消
      //     Fixture: 'Fixture', // 排赛
      //     Played: 'Played', // 结束
      //     Playing: 'Playing', // 赛中
      //     Postponed: 'Postponed', // 推迟
      //     Suspended: 'Suspended', // 暂停
      //   },
      // }),
    },
  },
  data() {
    return {
      sportsTypeArr: ['combat', 'uncombat'],
      matchStatusObj: {
        CANCELLED: 3,
        DELAYED: 3,
        FINISHED: 2,
        GETTING_READY: 0,
        INTERRUPTED: 3,
        POSTPONED: 3,
        RESCHEDULED: 3,
        RUNNING: 1,
        SCHEDULED: 0,
        SCHEDULED_BREAK: 1,
        UNSCHEDULED: 2,
      },
      matchStatusColorArr: [
        {
          colorClass: 'unstart',
          key: ['GETTING_READY', 'SCHEDULED'],
          name: ['已就绪', '按日程计划'],
        },
        {
          colorClass: 'playing',
          key: ['RUNNING', 'SCHEDULED_BREAK'],
          name: ['比赛中', '中场休息'],
        },
        {
          colorClass: 'finished',
          key: ['FINISHED', 'UNSCHEDULED'],
          name: ['已结束', '未安排'],
        },
        {
          colorClass: 'other',
          key: [
            'CANCELLED',
            'DELAYED',
            'INTERRUPTED',
            'POSTPONED',
            'RESCHEDULED',
          ],
          name: ['已取消', '延误', '中断', '推迟', '改期'],
        },
      ],
      matchStatusArr: {
        //足球世界杯
        Cancelled: 'Cancelled', // 取消
        Fixture: 'Fixture', // 排赛
        Played: 'Played', // 结束
        Playing: 'Playing', // 赛中
        Postponed: 'Postponed', // 推迟
        Suspended: 'Suspended', // 暂停
      },
    }
    // CANCELLED 已取消
    // DELAYED 延误
    // FINISHED 已结束
    // GETTING_READY 已就绪
    // INTERRUPTED 中断
    // POSTPONED 推迟
    // RESCHEDULED 改期
    // RUNNING 比赛中
    // SCHEDULED 按日程计划
    // SCHEDULED_BREAK 中场休息
    // UNSCHEDULED 未安排
  },
  computed: {
    customClassName() {
      let name = ''
      if (
        ['FootballLeague', 'BasketballLeague'].includes(this.matchModeObj.mode)
      ) {
        name =
          this.data && this.data.length > 3
            ? 'alignTop borderTop1px'
            : 'alignCenter borderTop1px'
      }
      return name
    },
  },
  methods: {
    matchStatusToMatchCN(matchStatus, type) {
      const { apiVal2WebValMap, webValStyleArr } = this.matchStatusOpts
      let index = apiVal2WebValMap[matchStatus]
      let item = webValStyleArr[index]
      let matchCN = item.name[item.key.indexOf(matchStatus)]
      return this._valPerFormatHandler(matchCN)
    },
    matchStatusClassName(item) {
      console.debug('this.matchStatusOpts:', this.matchStatusOpts)
      if (this.matchStatusOpts) {
        return ''
      } else {
        return this.matchStatusOpts.webValStyleArr[
          this.matchStatusOpts.apiVal2WebValMap[item.matchStatus]
        ].colorClass
      }
    },
    matchItemIsShareClassName(item) {
      if (this.matchStatusOpts && this.matchStatusOpts.notSupportShareArr) {
        return this.matchStatusOpts.notSupportShareArr.includes(
          item.matchStatus
        )
          ? 'none itemGreyColor'
          : this.chooseState
      } else {
        return this.chooseState
      }
    },
    goDetail(item) {
      console.debug(
        'goDetail:',
        item,
        this.openNewWeb,
        this.localStorageName,
        this.$dynamicConfig,
        this.detailPathName
      )
      if (this.themeClass === 'poster') {
        this.$emit('posterEvent', {
          type: this.themeClass,
          data: item,
        })
        return
      }
      if (this.chooseState === 'choose' && this.localStorageName) {
        let chooseObj = this.$localStorage.getItem(this.localStorageName)
          ? JSON.parse(this.$localStorage.getItem(this.localStorageName))
          : {
              cid: this.currCid,
              // date: this.localStorageSaveDate,
              chooseItemArr: [],
              chooseIdArr: [],
            }
        if (chooseObj.cid === this.currCid) {
          if (chooseObj.chooseItemArr.length === 0) {
            let newItem = JSON.parse(JSON.stringify(item))
            newItem.isChooseFlag = true
            chooseObj.chooseItemArr.push(newItem)
            chooseObj.chooseIdArr.push(item.chooseId)
          } else {
            let chooseItemArr = []
            let chooseIdArr = []
            chooseObj.chooseItemArr.forEach((chooseItem) => {
              if (chooseItem.chooseId !== item.chooseId) {
                chooseItemArr.push(chooseItem)
                chooseIdArr.push(chooseItem.chooseId)
              }
            })
            if (chooseItemArr.length === chooseObj.chooseItemArr.length) {
              let newItem = JSON.parse(JSON.stringify(item))
              newItem.isChooseFlag = true
              chooseItemArr.push(newItem)
              chooseIdArr.push(item.chooseId)
            }
            chooseObj.chooseItemArr = chooseItemArr
            chooseObj.chooseIdArr = chooseIdArr
          }
          this.$localStorage.setItem(
            this.localStorageName,
            JSON.stringify(chooseObj)
          )
          this.$emit('changeChooseNumEvent', {
            localStorageName: this.localStorageName,
            val: chooseObj.chooseIdArr.length,
            init: false,
          })
          console.debug('chooseObj:', chooseObj)
        } else {
          console.error('错误：赛事不同')
        }
      } else if (this.detailPathName) {
        let query = null
        let detailPathName = ''
        let params = null
        if (
          this.matchModeObj &&
          ['compreSportsMeet', 'tennis'].includes(this.matchModeObj.mode)
        ) {
          // 因为综合性赛事赛果里面，大小项，比赛都可以切换，因此需要保存数据到缓存中
          let currSportsDetail = {
            sportsId: item.sportsId,
            eventId: item.eventId,
            matchId: item.matchId,
            sportsName: item.sportsName,
            eventName: item.eventName,
            // matchDetail: item
          }
          console.debug(
            'sportsDetail_compreScore:',
            currSportsDetail,
            this.currThemeObj.moduleRouteNameEn
          )
          this.$localStorage.setItem(
            'mixtmt_platfromV4_currSportsDetail',
            JSON.stringify(currSportsDetail)
          )
          query = {
            cid: this.currCid,
            sid: this.currSid,
            sportsId: item.sportsId,
            eventId: item.eventId,
            mid: item.matchId,
          }
          params = {
            groupIndex: item.groupIndex ? item.groupIndex : '-1',
          }
          detailPathName = `${this.detailPathName}_${this.currThemeObj.moduleRouteNameEn}`
        } else if (
          this.matchModeObj &&
          ['FIFAWorldCup', 'FootballLeague'].includes(this.matchModeObj.mode)
        ) {
          query = {
            cid: item.competitionId,
            sid: item.seasonId,
            mid: item.matchId,
          }
          detailPathName = `${this.detailPathName}`
        } else if (
          this.matchModeObj &&
          this.matchModeObj.mode === 'badminton'
        ) {
          query = {
            cid: this.currCid,
            sid: item.seasonId,
            sportsId: 'BDM', // 羽毛球写死 BDM
            eventId: item.eventCode,
            mid: item.matchId,
          }
          // let secPathName = ''
          // if (this.currCid === '503') {
          //   secPathName = 'BDMTAU' // 汤尤杯
          // }
          detailPathName = `${this.detailPathName}_${this.currThemeObj.moduleRouteNameEn}`
        } else if (
          this.matchModeObj &&
          this.matchModeObj.mode === 'BasketballLeague'
        ) {
          // object
          // this.detailPathName = [
          //   {
          //     pathName: 'CBAScheduleDetailPreMatch',
          //     matchStatus: '1',
          //   },
          //   {
          //     pathName: 'CBAScheduleDetailPreMatch',
          //     matchStatus: '5',
          //   },
          //   {
          //     pathName: 'CBAScheduleDetailAnalysis',
          //     matchStatus: 'all',
          //   },
          // ]
          this.detailPathName.forEach((pathItem) => {
            if (item.matchStatus + '' === pathItem.matchStatus) {
              detailPathName = pathItem.pathName
            }
          })
          if (!detailPathName) {
            detailPathName =
              this.detailPathName[this.detailPathName.length - 1].pathName
          }
        }
        console.debug(
          'this.detailPathName:',
          this.detailPathName,
          detailPathName,
          query,
          params
        )
        this.pageJump(this.$router, detailPathName, query, params)
        // this.openNewWeb(this.$router, detailPathName, query, params)
      }
    },
    matchItem_checkbox(matchItem, actItem) {
      this.$emit('clickMatchItemCheckboxItemEvent', {
        matchItem,
        actItem,
        type: this.channelType ? this.channelType : '',
      })
      console.debug('matchItem_checkbox')
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .schedule_match_list {
    width: 100%;
    height: auto;
    &.borderTop1px {
      border-top: 1px solid var(--mixtmt_greyColor5);
    }
    &.onlyDisplay {
      &.alignCenter {
        justify-content: center;
      }
      &.alignTop {
        justify-content: flex-start;
      }
      .match_list_item {
        &.compreSportsMeet,
        &.tennis {
          .item_matchLeft {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 42.53vw;
            &.isShowChannelTvList {
              width: 50vw;
            }
            .matchLeft_colum1 {
              width: calc(100% - 30.3vw);
            }
            .matchLeft_colum2 {
              width: 30.3vw;
            }
          }
          .item_matchCenter {
            width: 19.75vw;
          }
        }
        &.FIFAWorldCup {
        }
        &.FootballLeague,
        &.BasketballLeague {
          .item_matchLeft {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 10.42vw;
            .matchLeft_colum1 {
              width: 100%;
            }
          }
          .item_matchCenter {
            width: calc(100% - 10.42vw - 6.94vw);
            .matchCenter_colum1 {
              width: 10.42vw;
            }
            .matchCenter_colum2 {
              width: calc(100% - 10.42vw);
            }
          }
        }
      }
    }
    .match_list_item {
      position: relative;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      height: auto;
      width: 100%;
      padding: 0.694vw 1.388vw;
      color: var(--mixtmt_greyColor3);
      border-bottom: 1px solid var(--mixtmt_greyColor5);
      transition: padding 0.3s linear;
      &.choose {
        padding: 0.694vw 1.388vw 0.694vw 2.776vw;
        .item_absChoose {
          width: 2.776vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          .checkbox_item {
            width: 1.388vw;
            height: 1.388vw;
            border-radius: 0.208vw;
            border: 1px solid var(--mixtmt_subColor1_1);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            background-color: var(--mixtmt_whiteColor);
            /* &.act {
                    background-color: var(--mixtmt_subColor1_1);
                    color: var(--mixtmt_whiteColor);
                  } */
            svg {
              opacity: 0;
              fill: var(--mixtmt_whiteColor);
              transition: all 0.3s linear;
            }
          }
        }
        &.chooseAct {
          .checkbox_item {
            background-color: var(--mixtmt_subColor1_1);
            svg {
              opacity: 1;
            }
          }
        }
      }
      .matchLeft_colum1,
      .matchCenter_colum1,
      .matchCenter_colum2 {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        height: auto;
      }
      /* &.FIFAWorldCup {
        align-items: center;
        .item_matchCenter {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          width: 42.778vw;
          font-weight: bold;
          .matchCenter_scoreArea {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            width: 14.666vw;
            font-size: 1.11vw;
            .matchStatus_notStarted {
              width: 5.2vw;
              height: 2.5vw;
              background-color: var(--mixtmt_subColor1_1);
              color: var(--mixtmt_whiteColor);
              text-align: center;
              line-height: 2.5vw;
            }
            .matchStatus_ongoing,
            .matchStatus_over {
              position: relative;
              display: flex;
              display: -webkit-flex;
              justify-content: center;
              align-items: center;
              width: 7.2vw;
              height: 2.5vw;
              background-color: var(--mixtmt_mainColor8);
              color: var(--mixtmt_subColor_main);
              span {
                flex: 1;
                text-align: center;
              }
              &::before {
                content: '\20';
                position: absolute;
                top: 10%;
                left: 50%;
                z-index: 2;
                width: 1px;
                height: 80%;
                background-color: var(--mixtmt_subColor_main);
              }
            }
            .matchStatus_over {
              background-color: var(--mixtmt_subColor_main05);
              color: var(--mixtmt_greyColor_main);
            }
          }
          .matchCenter_leftTeam,
          .matchCenter_rightTeam {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            width: 14.056vw;
            img {
              display: block;
              width: 2.7vw;
              height: 1.8vw;
              overflow: hidden;
              object-fit: contain;
            }
            .teamName {
              width: calc(100% - 2.7vw);
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .matchCenter_leftTeam {
            justify-content: flex-end;
            .teamName {
              padding-right: 0.7vw;
              text-align: right;
            }
          }
          .matchCenter_rightTeam {
            justify-content: flex-start;
            .teamName {
              padding-left: 0.7vw;
            }
          }
        }
        .item_matchLeft,
        .item_matchRight {
          flex: 1;
        }
        .item_matchRight {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-end;
          align-items: center;
          color: var(--mixtmt_greyColor2);
          .matchRight_icon {
            width: 1.042vw;
            height: 1.042vw;
            background-image: var(--mixtmt_scheduleMatchList_sportHall_icon);
            background-size: 100% auto;
            background-position: left top;
            background-repeat: no-repeat;
          }
          .matchRight_text {
            padding-left: 0.2778vw;
          }
        }
      } */
      &.badminton,
      &.FIFAWorldCup {
        align-items: center;
        .matchLeft_colum1_row1 {
          margin-bottom: 0.347vw;
        }
        .item_matchLeft {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 20.83vw;
          .matchLeft_colum1 {
            width: 100%;
            .matchLeft_colum1_row1 {
              width: 100%;
              font-size: 1.11vw;
              line-height: 2.083vw;
              height: 2.083vw;
              /* font-weight: bold; */
            }
            .matchLeft_colum1_row2 {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              width: 100%;
              height: 2.083vw;
              font-size: 1.11vw;
              color: var(--mixtmt_greyColor2);
            }
          }
        }
        .item_matchCenter {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          width: 42.778vw;
          font-weight: bold;
          .matchCenter_scoreArea {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            width: 14.666vw;
            font-size: 1.11vw;
            .matchStatus_notStarted {
              width: 5.2vw;
              height: 2.5vw;
              background-color: var(--mixtmt_subColor1_1);
              color: var(--mixtmt_whiteColor);
              text-align: center;
              line-height: 2.5vw;
            }
            .matchStatus_ongoing,
            .matchStatus_over {
              position: relative;
              display: flex;
              display: -webkit-flex;
              justify-content: center;
              align-items: center;
              width: 7.2vw;
              height: 2.5vw;
              background-color: var(--mixtmt_mainColor8);
              color: var(--mixtmt_subColor_main);
              span {
                flex: 1;
                text-align: center;
              }
              &::before {
                content: '\20';
                position: absolute;
                top: 10%;
                left: 50%;
                z-index: 2;
                width: 1px;
                height: 80%;
                background-color: var(--mixtmt_subColor_main);
              }
            }
            .matchStatus_over {
              background-color: var(--mixtmt_subColor_main05);
              color: var(--mixtmt_greyColor_main);
            }
          }
          .matchCenter_leftTeam,
          .matchCenter_rightTeam {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            width: 14.056vw;
            img {
              display: block;
              width: 2.7vw;
              height: 1.8vw;
              overflow: hidden;
              object-fit: contain;
            }
            .teamName {
              width: calc(100% - 2.7vw);
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .matchCenter_leftTeam {
            justify-content: flex-end;
            .teamName {
              padding-right: 0.7vw;
              text-align: right;
            }
          }
          .matchCenter_rightTeam {
            justify-content: flex-start;
            .teamName {
              padding-left: 0.7vw;
            }
          }
        }
        .item_matchLeft,
        .item_matchRight {
          flex: 1;
        }
        .item_matchRight {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-end;
          align-items: center;
          color: var(--mixtmt_greyColor2);
          .matchRight_icon {
            width: 1.042vw;
            height: 1.042vw;
            background-image: var(--mixtmt_scheduleMatchList_sportHall_icon);
            background-size: 100% auto;
            background-position: left top;
            background-repeat: no-repeat;
          }
          .matchRight_text {
            padding-left: 0.2778vw;
          }
        }
      }

      &.compreSportsMeet,
      &.tennis {
        align-items: flex-start;
        .matchLeft_colum1,
        .matchLeft_colum2,
        .matchCenter_colum1,
        .matchCenter_colum2 {
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-direction: column;
          height: auto;
        }
        .matchLeft_colum1_row1,
        .matchLeft_colum2_row1,
        .matchCenter_colum1_row,
        .matchCenter_colum2_row {
          margin-bottom: 0.347vw;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .item_matchLeft {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 41.53vw;
          transition: width 0.3s linear;
          &.doubleNationalityOfTeam {
            /* 中网双打因为一只球队有俩个国家，整体变高 */
            .matchLeft_colum1 {
              .matchLeft_colum1_row1,
              .matchLeft_colum1_row2 {
                line-height: 3.2vw;
                height: 3.2vw;
              }
            }
            .matchLeft_colum2 {
              .matchLeft_colum2_row1,
              .matchLeft_colum2_row2 {
                line-height: 3.2vw;
                height: 3.2vw;
              }
            }
          }
          &.isShowChannelTvList {
            width: 60vw;
            .matchLeft_colum1_row1,
            .matchLeft_colum1_row1_colum2 {
              width: auto;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
            }
            .matchLeft_colum1_row1_colum2 {
              margin-left: 1.11vw;
            }
          }
          .matchLeft_colum1 {
            width: calc(100% - 30vw);
            .matchLeft_colum1_row1 {
              width: 100%;
              font-size: 1.388vw;
              line-height: 2.083vw;
              height: 2.083vw;
              font-weight: bold;
            }
            .matchLeft_colum1_row2 {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              width: 100%;
              height: 2.083vw;
            }
            .national_icon {
              padding-right: 0.694vw;
              width: 2.083vw;
              height: 0.903vw;
              overflow: hidden;
              background-image: var(--mixtmt_china_square_icon);
              background-size: auto 100%;
              background-repeat: no-repeat;
              background-position: left center;
            }
            .medal_icon {
              padding-right: 0.694vw;
              width: 1.805vw;
              height: 1.11vw;
              overflow: hidden;
              background-image: var(--mixtmt_medal_gold_icon);
              background-size: auto 100%;
              background-repeat: no-repeat;
              background-position: left center;
            }
          }
          .matchLeft_colum2 {
            width: 30vw;
            .matchLeft_colum2_row1 {
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 1.38vw;
              line-height: 2.083vw;
              height: 2.083vw;
              font-weight: bold;
            }
            .matchLeft_colum2_row2 {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              width: 100%;
              height: 2.083vw;
              .sportHall_icon {
                width: 1.11vw;
                height: 1.11vw;
                background-image: var(
                  --mixtmt_scheduleMatchList_sportHall_icon
                );
                background-size: 100% auto;
                background-position: 0 0;
                background-repeat: no-repeat;
              }
              .sportHall_name {
                width: calc(100% - 1.11vw);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 1.11vw;
                line-height: 2.083vw;
                padding: 0 0.486vw;
                color: var(--mixtmt_greyColor2);
              }
            }
          }
        }
        .item_matchCenter {
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          width: 20.75vw;
          &.doubleNationalityOfTeam {
            .teamColum {
              width: 100%;
              height: 3.2vw;
              display: flex;
              display: -webkit-flex;
              align-items: center;
              flex-direction: column;
              margin-bottom: 0.347vw;
              height: 3.2vw;
              justify-content: center;
              &.oneRow {
                .delegationLogo {
                  width: 1.68vw;
                  height: 1.44vw;
                }
                .delegationName {
                  font-size: 1.11vw;
                }
              }
              &.twoRow {
                .matchCenter_colum1_row {
                  height: 1.4vw;
                }
              }
              &:last-child {
                margin-bottom: 0;
              }
            }
            .matchCenter_colum1 {
              .matchCenter_colum1_row {
                margin-bottom: 0;
              }
            }
            .matchCenter_colum2 {
              .matchCenter_colum2_row {
                height: 3.2vw;
                line-height: 3.2vw;
              }
            }
          }
          .matchCenter_colum1 {
            width: 15.98vw;
            .matchCenter_colum1_row {
              width: 100%;
              height: 2.083vw;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              .delegationLogo {
                width: 1.38vw;
                height: 1.18vw;
                overflow: hidden;
                background-color: var(--mixtmt_greyColor0);
                &.isLogo {
                  background-color: transparent;
                }
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  display: block;
                }
              }
              .delegationName {
                width: calc(100% - 1.38vw);
                padding-left: 0.972vw;
                font-size: 0.972vw;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .matchCenter_colum2 {
            width: calc(100% - 15.98vw);
            padding-left: 0.694vw;
            .matchCenter_colum2_row {
              width: 100%;
              height: 2.083vw;
              font-size: 0.972vw;
              line-height: 2.083vw;
              font-weight: bold;
              text-align: left;
              padding-right: 0.347vw;
            }
          }
          &.uncombat {
            .matchCenter_colum2_row {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              padding-right: 0;
              .medalIcon {
                width: 1.11vw;
                height: 1.11vw;
                overflow: hidden;
                background-size: auto 100%;
                background-repeat: no-repeat;
                background-position: left center;
                &.ME_GOLD {
                  background-image: var(--mixtmt_medal_gold_icon);
                }
                &.ME_SILVER {
                  background-image: var(--mixtmt_medal_silver_icon);
                }
                &.ME_BRONZE {
                  background-image: var(--mixtmt_medal_bronze_icon);
                }
              }
            }
          }
        }
        .item_matchRight {
          position: absolute;
          right: 1.388vw;
          top: 50%;
          z-index: 10;
          transform: translateY(-50%);
          width: 6.94vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-end;
          align-items: center;
          .matchRight_status {
            width: 6.94vw;
            height: 2.083vw;
            line-height: 2.083vw;
            font-size: 0.972vw;
            text-align: center;
            border-radius: 0.278vw;
            &.unstart {
              color: var(--mixtmt_subColor3_1);
              border: 1px solid var(--mixtmt_subColor3_1);
            }
            &.playing {
              color: var(--mixtmt_subColor5_1);
              border: 1px solid var(--mixtmt_subColor5_1);
            }
            &.finished {
              color: var(--mixtmt_greyColor2);
              border: 1px solid var(--mixtmt_greyColor2);
            }
            &.other {
              color: var(--mixtmt_subColor1_1);
              border: 1px solid var(--mixtmt_subColor1_1);
            }
          }
        }
      }

      &.FootballLeague,
      &.BasketballLeague {
        .item_matchLeft {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 20.83vw;
          .matchLeft_colum1 {
            width: 100%;
            .matchLeft_colum1_row1 {
              width: 100%;
              font-size: 1.11vw;
              line-height: 2.083vw;
              height: 2.083vw;
              font-weight: bold;
            }
            .matchLeft_colum1_row2 {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              width: 100%;
              height: 2.083vw;
              font-size: 1.11vw;
              color: var(--mixtmt_greyColor2);
            }
          }
        }
        .item_matchCenter {
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          width: calc(100% - 34.71vw);
          .matchCenter_colum1 {
            width: 20.83vw;
            .matchCenter_colum1_row {
              width: 100%;
              height: 2.083vw;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              .delegationLogo {
                width: 1.68vw;
                height: 1.68vw;
                border-radius: 50%;
                overflow: hidden;
                background-color: var(--mixtmt_greyColor0);
                &.isLogo {
                  background-color: transparent;
                }
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  display: block;
                }
              }
              .delegationName {
                width: calc(100% - 1.68vw);
                padding-left: 0.972vw;
                font-size: 0.972vw;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .matchCenter_colum2 {
            width: calc(100% - 20.83vw);
            padding-left: 0.694vw;
            &.playing {
              color: var(--mixtmt_subColor3_1);
            }
            .matchCenter_colum2_row {
              width: 100%;
              height: 2.083vw;
              font-size: 0.972vw;
              line-height: 2.083vw;
              font-weight: bold;
              text-align: left;
              padding-right: 0.347vw;
            }
          }
        }
        .item_matchRight {
          position: absolute;
          right: 1.388vw;
          top: 50%;
          z-index: 10;
          transform: translateY(-50%);
          width: 6.94vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-end;
          align-items: center;
          .matchRight_status {
            width: 6.94vw;
            height: 2.083vw;
            line-height: 2.083vw;
            font-size: 0.972vw;
            text-align: center;
            border-radius: 0.278vw;
            &.unstart {
              color: var(--mixtmt_greyColor2);
              border: 1px solid var(--mixtmt_greyColor2);
            }
            &.playing {
              color: var(--mixtmt_subColor3_1);
              border: 1px solid var(--mixtmt_subColor3_1);
            }
            &.finished {
              color: var(--mixtmt_greyColor2);
              border: 1px solid var(--mixtmt_greyColor2);
            }
            &.other {
              background-color: var(--mixtmt_greyColor0);
              color: var(--mixtmt_greyColor2);
              border: 1px solid var(--mixtmt_greyColor0);
            }
          }
        }
      }
      .matchItem_checkbox {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: auto;
        margin-right: 0.974vw;
        .matchItem_channelItem {
          width: 1.11vw;
          height: 1.11vw;
          border-radius: 0.208vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          background-color: var(--mixtmt_whiteColor);
          &.radio {
            border-radius: 50%;
            border: 1px solid var(--mixtmt_greyColor2);
          }
          &.checkbox {
            border: 1px solid var(--mixtmt_greyColor2);
          }
          svg {
            opacity: 0;
            fill: var(--mixtmt_whiteColor);
            transition: all 0.3s linear;
          }
        }
        .matchItem_channelItem_text {
          padding: 0 0.374vw;
          font-size: 0.974vw;
          color: var(--mixtmt_greyColor2);
          &.channelName {
            padding: 0 0.374vw 0 0;
          }
        }
        &.act {
          .matchItem_channelItem {
            background-color: var(--mixtmt_scheduleItem_actSwitchColor);
            border: 1px solid var(--mixtmt_scheduleItem_actSwitchColor);
            svg {
              opacity: 1;
            }
          }
          .matchItem_channelItem_text {
            color: var(--mixtmt_scheduleItem_actSwitchColor);
            font-weight: bold;
          }
        }
      }
      .item_absChoose {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 0;
        height: 100%;
        transition: width 0.3s linear;
      }
    }
  }
}

.mixtmt_pc {
  .schedule_match_list {
    .match_list_item:not(.none) {
      &:hover,
      &.choose.chooseAct {
        &.compreSportsMeet,
        &.tennis {
          background-color: var(--mixtmt_scheduleItem_actBgColor);
          color: var(--mixtmt_whiteColor);
          /* .item_matchCenter {
              } */
          .item_matchRight {
            .matchRight_status.unstart {
              color: var(--mixtmt_whiteColor);
              background-color: var(--mixtmt_subColor3_1);
              border: 1px solid var(--mixtmt_subColor3_1);
            }
            .matchRight_status.playing {
              color: var(--mixtmt_whiteColor);
              background-color: var(--mixtmt_subColor5_1);
              border: 1px solid var(--mixtmt_subColor5_1);
            }
            .matchRight_status.finished {
              opacity: 0.45;
              color: var(--mixtmt_scheduleItem_actBgColor);
              background-color: var(--mixtmt_whiteColor);
              border: 1px solid var(--mixtmt_whiteColor);
            }
            .matchRight_status.other {
              color: var(--mixtmt_whiteColor);
              background-color: var(--mixtmt_subColor1_1);
              border: 1px solid var(--mixtmt_subColor1_1);
            }
          }
          .item_matchLeft {
            .matchLeft_colum1 {
              .matchLeft_colum1_row2 {
                color: var(--mixtmt_whiteColor);
                .matchItem_checkbox,
                .matchItem_channelItem_text.act {
                  .matchItem_channelItem_text {
                    color: var(--mixtmt_whiteColor);
                  }
                }
              }
            }
            .matchLeft_colum2 {
              .matchLeft_colum2_row2 {
                .sportHall_name {
                  color: var(--mixtmt_whiteColor);
                }
              }
            }
          }
        }
        &.FIFAWorldCup,
        &.badminton {
          background-color: var(--mixtmt_scheduleItem_actBgColor);
          color: var(--mixtmt_whiteColor);
          .item_matchLeft {
            .matchLeft_colum1 {
              .matchLeft_colum1_row2 {
                color: var(--mixtmt_whiteColor);
                .matchItem_checkbox,
                .matchItem_channelItem_text.act {
                  .matchItem_channelItem_text {
                    color: var(--mixtmt_whiteColor);
                  }
                }
              }
            }
          }
          .item_matchCenter {
            .matchCenter_scoreArea {
              .matchStatus_notStarted {
                background-color: var(--mixtmt_whiteColor);
                color: var(--mixtmt_blackColor);
              }
              .matchStatus_ongoing,
              .matchStatus_over {
                background-color: var(--mixtmt_whiteColor);
                color: var(--mixtmt_blackColor);
                &::before {
                  background-color: var(--mixtmt_greyColor0);
                }
              }
            }
          }
          .item_matchRight {
            color: var(--mixtmt_whiteColor);
          }
        }
      }
      &.choose.chooseAct,
      &.choose,
      &.default {
        cursor: pointer;
      }
    }
  }
}
</style>
